export default "__VITE_ASSET__6bh_KB7K__"